import { TAppThunkDispatch, TGetState } from '~/src/store';

import { setTransactions, TPaymentTransaction } from '../actionCreators';

export const createTransaction = (id: TPaymentTransaction['id']) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const {
            payment: { transactions },
        } = getState();

        const payload = [
            ...transactions,
            {
                id,
                payed: false,
            },
        ];

        dispatch(setTransactions(payload));
    };
};

export default createTransaction;
